var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 20.002H3.743a3.352 3.352 0 0 1-3.343-3.343V3.343A3.351 3.351 0 0 1 3.744 0H17.06a3.351 3.351 0 0 1 3.344 3.343V16.66a3.34 3.34 0 0 1-3.343 3.343Z",
    fill: "#E8E1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.406 15.139a5.101 5.101 0 0 1-3.63-1.503 5.1 5.1 0 0 1-1.504-3.631c0-1.372.534-2.661 1.503-3.63a5.101 5.101 0 0 1 3.63-1.504c1.373 0 2.662.534 3.632 1.503a5.101 5.101 0 0 1 1.503 3.631 5.1 5.1 0 0 1-1.503 3.63 5.115 5.115 0 0 1-3.631 1.504Zm0-9.175a4.044 4.044 0 0 0-4.042 4.041 4.044 4.044 0 0 0 4.042 4.041 4.044 4.044 0 0 0 4.041-4.041c-.008-2.226-1.815-4.041-4.041-4.041ZM16.54 4.702a.986.986 0 1 0 0-1.971.986.986 0 0 0 0 1.971Z",
    fill: "#391A84"
  })));
};
export default SvgInstagram;